/* Lista de desejos DM01: handles em localStorage "dm_wishlist", evento window "dm:wishlist". */
(function () {
  if (window.dmWishlist) return;
  var KEY = 'dm_wishlist';
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  var write = function (list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} };
  var sync = function () {
    var list = read();
    document.querySelectorAll('[data-dm-wishlist]').forEach(function (b) {
      var on = list.indexOf(b.dataset.dmWishlist) > -1;
      b.classList.toggle('is-added', on);
      b.setAttribute('aria-pressed', on);
      b.title = on ? 'Added to wishlist' : 'Add to wishlist';
    });
  };
  window.dmWishlist = {
    get: read,
    toggle: function (handle) {
      var list = read(), i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1); else list.push(handle);
      write(list); sync();
      window.dispatchEvent(new CustomEvent('dm:wishlist', { detail: { handle: handle, added: i === -1, list: list } }));
    },
    sync: sync
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dm-wishlist]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    window.dmWishlist.toggle(b.dataset.dmWishlist);
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  new MutationObserver(function () { clearTimeout(window.__dmWlT); window.__dmWlT = setTimeout(sync, 50); }).observe(document.documentElement, { childList: true, subtree: true });
})();
